import { render, staticRenderFns } from "./BCXDropdown.vue?vue&type=template&id=1c7762f5&scoped=true"
import script from "./BCXDropdown.vue?vue&type=script&lang=ts"
export * from "./BCXDropdown.vue?vue&type=script&lang=ts"
import style0 from "./BCXDropdown.vue?vue&type=style&index=0&id=1c7762f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7762f5",
  null
  
)

export default component.exports